/*
 |--------------------------------------------------------------------------
 | Card
 |
 | This module adds functionality to the Sitecore and Angular version of
 | the card component
 |--------------------------------------------------------------------------
 */

class ACard {
  constructor(element) {
    this.element = element;
    this.main = this.element.querySelector('.a-card__main');

    // Add observers
    this.resizeObserver = new ResizeObserver(() => {
      this.updateOverflow();
    });

    this.mutationObserver = new MutationObserver(() => {
      this.updateOverflow();
    });

    if (this.main) {
      this.resizeObserver.observe(this.main);
      this.mutationObserver.observe(this.main, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    // Update for the first time
    this.updateOverflow();
  }

  // Set overflow classname when card main does overflow
  updateOverflow() {
    const overflow = this.main.scrollHeight > this.main.offsetHeight;
    const className = 'a-has-overflow';

    if (overflow && !this.element.classList.contains(className)) {
      this.element.classList.add(className);
    } else if (!overflow && this.element.classList.contains(className)) {
      this.element.classList.remove(className);
    }
  }
}

// Module selector
const ACardClassname = 'a-card';

// Initiate module
function createACardInstance(element) {
  if (!element.cardClass) {
    element.cardClass = new ACard(element);
  }
}

document.querySelectorAll(`.${ACardClassname}`).forEach(createACardInstance);

// Create card instances on DOM mutation
const ACardObserver = new MutationObserver(function (mutations) {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((element) => {
      document
        .querySelectorAll(`.${ACardClassname}`)
        .forEach(createACardInstance);
    });
  });
});

ACardObserver.observe(document, {
  attributes: false,
  childList: true,
  characterData: false,
  subtree: true,
});
